import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { FoodHistoryProvider } from './context/FoodHistoryContext';
import { theme } from './theme';
import AppContent from './AppContent';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <FoodHistoryProvider>
          <Router>
            <AppContent />
          </Router>
        </FoodHistoryProvider>
      </AuthProvider>
    </ThemeProvider>
  );
} 